import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./transact_campus_card_host_system.js";
//#region src/transact_campus_card_host_system_helper.ts
var transact_campus_card_host_system_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(hostSystem) {
	switch (hostSystem) {
		case "tse": return "TSE";
		case "idx": return "IDX";
	}
}
//#endregion
export { name, transact_campus_card_host_system_helper_exports };

//# sourceMappingURL=transact_campus_card_host_system_helper.js.map